import { render } from "./config-list-header.vue?vue&type=template&id=71b1c564&ts=true"
import script from "./config-list-header.ts?vue&type=script&lang=ts"
export * from "./config-list-header.ts?vue&type=script&lang=ts"

import "./config-list-header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__